export const VISIBILITY_PUBLIC = 'urn:alltrails:visibility:public';
export const VISIBILITY_FOLLOWERS_ONLY = 'urn:alltrails:visibility:followers-only';
export const VISIBILITY_PRIVATE = 'urn:alltrails:visibility:private';

export type Visibility = typeof VISIBILITY_PUBLIC | typeof VISIBILITY_FOLLOWERS_ONLY | typeof VISIBILITY_PRIVATE;

export type VisibilitySetting = {
  visibility: Visibility;
};
